import { useLocation, useSearchParams } from "react-router-dom";
import type { AberturaDeModal } from "@/rotas";

/*
 * O modal que a consulta abre: `?abrir=nova-conta`, `?abrir=novo-convenio&conta={id}`.
 *
 * Ação de pendência é navegação (design D2): a página do cedente não conhece os modais
 * das abas, e cada aba só olha o próprio `abrir`. Aqui mora o resto do combinado:
 * fechar limpa o parâmetro com `replace`, e abrir por botão da própria aba também é
 * `replace`, para o histórico não ganhar uma entrada que só reabre o modal no voltar.
 *
 * A URL qualquer um cola. Quem usa confere o papel antes de montar o modal, como já
 * confere antes de mostrar o botão.
 */
const PARAMETROS = ["abrir", "conta"] as const;

export function useModalNaUrl() {
  const [parametros, setParametros] = useSearchParams();
  const estado: unknown = useLocation().state;

  function aplicar(mudar: (proximos: URLSearchParams) => void) {
    const proximos = new URLSearchParams(parametros);
    for (const parametro of PARAMETROS) proximos.delete(parametro);
    mudar(proximos);
    // O `state` guarda de que lista o operador veio, para o "« voltar".
    setParametros(proximos, { replace: true, state: estado });
  }

  return {
    /** O valor de `?abrir=`, ou `null`. */
    abrir: parametros.get("abrir"),
    /** O `conta_id` de `?conta=`, ou `null`. */
    conta: parametros.get("conta"),
    abrirModal: (abertura: AberturaDeModal) =>
      aplicar((proximos) => {
        for (const [nome, valor] of Object.entries(abertura)) proximos.set(nome, valor);
      }),
    fechar: () => aplicar(() => undefined),
  };
}
